$w.onReady(function () {
	//Wait for dataset1 to finish loading
	$w("#dynamicDataset").onReady(function () {
		//get the value
		const textValue = $w('#descriptiontext').text;
		//collapse the text box if textValue is empty
		if (textValue === '') {
			$w('#descriptiontext').collapse();
		}
	});
});